import { Fragment, useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { Cloudinary } from '@cloudinary/url-gen';
import { apiEndpoint } from './constants/api';
import Modal from './components/Modal';
import { EmployerSearchTable } from './components/EmployerSearchTable';
import Header from './components/Header';
import Aside from './components/Aside';
import ProdzFooter from './components/Footer';
import Nav from './components/Nav';

const connector = connect((state, ownProps) => ({ 
 ...state.user,
 employer: {...state.user.currentEmployer}
}), {});
function EmployerSearch({ user, employer }) {
  const [isOpened, setIsOpened] = useState(false);
  const [employerData, setEmployerData] = useState([]);
  const [activeEmployer, setActiveEmployer] = useState({name: '', website: ''});
  const [query, setQuery] = useState('');
  const [searching, setSearching] = useState(false);
  const timeout = useRef();

  const cld = new Cloudinary({
    cloud: {
      cloudName: 'prodz-com',
      uploadPreset: 'employer_logos'
    }
  });

  const onSubmit = (evt) => {
    evt.preventDefault();
  }

  const findEmployerData = async ({ target: { value } }) => {
    setSearching(true);
    clearTimeout(timeout.current);
    setQuery(value);
    timeout.current = setTimeout(() => loadEmployerData(value), 700);
  };

  const loadEmployerData = async (q) => {
    const { data } = await axios.post(apiEndpoint('/search/employers'), { q });
    setEmployerData(data);
    setSearching(false);
  };

  const updateActiveEmployer = (key, { target: { value } }) => {
    setActiveEmployer({ ...activeEmployer, [key]: value });
  }

  const saveEmployerData = async () => {
    const { data } = await axios.post(apiEndpoint('/admin/employer'), activeEmployer);
    loadEmployerData();
    closeModal();
  }

  const createNewEmployer = () => {
    setActiveEmployer({ name: '', website: ''});
    setIsOpened(true);
  }

  const closeModal = () => {
    setIsOpened(false);
  }

  useEffect(() => {
    loadEmployerData();
  }, []);

  return (
    <>
    <Helmet>
      <title>Employer Search | Productions.com</title>
    </Helmet>
      <div className="min-h-full">
        <Nav />
        <>
          <Header publicId={employer.logo} />
          <Aside />
          <main className="p-4 sm:ml-64">
            <div className="mx-auto sm:px-6 lg:px-8">
              {/* Replace with your content */}
              <div className="flex flex-row justify-between content-start mb-3">
                <h1 className="text-2xl">Employers</h1>
                <button
                  type="button"
                  onClick={createNewEmployer}
                    className="text-white bg-blue-600 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center mr-2">
                    + New Employer
                </button>
              </div>
              <div>
                <div className="pb-2">
                  <form onSubmit={onSubmit}>
                    <label
                      htmlFor="project-search"
                      className="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white"
                    >
                      Search
                    </label>
                    <div className="relative">
                      <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                        <svg
                          aria-hidden="true"
                          className="w-5 h-5 text-gray-500 dark:text-gray-400"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                          ></path>
                        </svg>
                      </div>
                      <input
                        onChange={findEmployerData}
                        type="search"
                        id="project-search"
                        className="block w-full p-6 px-10 text-lg text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        placeholder="Search Employers..."
                        required
                      />
                    </div>
                  </form>
                </div>
                {employerData && employerData.length ? (
                  <EmployerSearchTable
                    cld={cld}
                    employerData={employerData}
                    loadEmployerData={loadEmployerData}
                    searching={searching}
                  />
                ) : (
                  <div className="w-full">
                    <div className="mx-auto">Loading Employers...</div>
                  </div>
                )}
              </div>
              <Modal
              title="Create Employer"
              isOpened={isOpened}
              onClose={closeModal}
              >
              <form className="w-full">
                <div className="text-lg text-left mb-5">
                  Create New Employer
                </div>
                <div className="my-5">
                  <label
                      htmlFor="project-name"
                      className="mb-2 text-lg font-medium text-gray-900 sr-only dark:text-white"
                    >
                      Employer Name
                    </label>
                    <div className="relative">
                      <input
                        type="search"
                        value={activeEmployer.name}
                        onChange={(d) => updateActiveEmployer('name', d)}
                        id="project-search"
                        className="block w-full p-6 px-10 text-lg text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        placeholder="Employer Name"
                        required
                      />
                    </div>
                </div>
                <div className="my-5">
                  <label
                      htmlFor="project-name"
                      className="mb-2 text-lg font-medium text-gray-900 sr-only dark:text-white"
                    >
                      Employer Website
                    </label>
                    <div className="relative">
                      <input
                        type="search"
                        value={activeEmployer.website}
                        onChange={(d) => updateActiveEmployer('website', d)}
                        id="project-search"
                        className="block w-full p-6 px-10 text-lg text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        placeholder="Employer Website"
                        required
                      />
                    </div>
                </div>
                
                <div className="my-2">
                  <button
                    type="button"
                    onClick={saveEmployerData}
                    className="text-white bg-blue-600 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 font-medium rounded-lg text-lg inline-flex items-center px-5 py-2.5 text-center mr-2"
                  >
                    Create Employer
                  </button>
                  <button
                    type="button"
                    onClick={closeModal}
                    className="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-lg font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </Modal>
              {/* /End replace */}
            </div>
            <ProdzFooter />
          </main>
        </>
      </div>
    </>
  );
}

export default connector(EmployerSearch)